import React from 'react'

export function Unauthorized() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-400">403</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mt-4">Acesso Negado</h2>
        <p className="text-gray-500 mt-2">
          Você não possui permissão para acessar esta página.
        </p>
        <button 
          onClick={() => window.history.back()}
          className="mt-6 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Voltar
        </button>
      </div>
    </div>
  )
}
